import React from 'react'
import { Link } from 'react-router-dom'

const SubHeader = (props) => {
    return (
        <>
            <section className="subheader-bg px-5">
                <div className="subheader-inner col-lg-5 col-md-8 col-12">
                    <p className='subheader-text'>{props.message}</p>
<i class="fa-solid fa-caret-down fs-4"></i>                    {/* <Link className='header-link' to='/'>Home</Link><span className='px-3'>|</span><span>{props.message}</span> */}
                </div>
            </section>

        </>
    )
}

export default SubHeader
